module.exports = __webpack_public_path__ + "img/Polish.d9232ee1.svg";